import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const LoadingScreen = () => (
  <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center">
    <div className="text-center">
      <div className="bg-blue-600 w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-4">
        <div className="w-8 h-8 border-3 border-white border-t-transparent rounded-full animate-spin"></div>
      </div>
      <h2 className="text-xl font-semibold text-white mb-2">ECP Capital</h2>
      <p className="text-blue-200">Carregando...</p>
    </div>
  </div>
);

const AccessDeniedScreen = ({ description }) => (
  <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 flex items-center justify-center">
    <div className="text-center bg-white p-8 rounded-xl shadow-xl max-w-md mx-4">
      <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Acesso Restrito</h2>
      <p className="text-gray-600 mb-6">
        {description ||
          "Você não tem permissão para acessar esta área com o seu perfil atual."}
      </p>
      <a
        href="/dashboard"
        className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
      >
        Voltar ao Dashboard
      </a>
    </div>
  </div>
);

/**
 * Guard de rota por role. Complementa ProtectedRoute (autenticação).
 */
const RoleRoute = ({ children, roles, description }) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!roles.includes(user?.role)) {
    return <AccessDeniedScreen description={description} />;
  }

  return children;
};

export default RoleRoute;
